module.exports = __webpack_public_path__ + "img/turbodrk.6ddc2981.png";